import { useEffect, useState } from 'react'
import Header from '../componets/headerwebsite/headerweb'
import FooterWeb from '../componets/footerwebsite/footerweb'
import { GET, POST } from '../../utils/apicalls';
import { API } from '../../config/api';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Carousel, Input, Modal, notification } from 'antd';
import background from "../../assets/background-for-all.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import Subcategory from './subcategory/subcategory';
import { Heart, MessageCircle, Share2 } from 'lucide-react';
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';



interface Product {
  id: number;
  productTitle: string;
  Price: number;
  descriptionProduct: string;
  brand: string;
  color: string;
  gender: string;
  size: string;
  shipping: string;
  stock_product?: string; // Add stock_product field
  productImage1?: string;
  productImage2?: string;
  productImage3?: string;
}



// Initialize dayjs plugins for timezone handling
dayjs.extend(utc);
dayjs.extend(timezone);
interface EngagementData {
  EngagementLike: number;
  EngagementComments: string[];
  EngagementShare: number;
}
function Categoryviewpage() {
  const { id } = useParams();
  const [data, setData] = useState<any>([]);
  const [ProductfilterData, setProductfilterData] = useState<any>([]);
  const [productImages, setProductImages] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const [offerdata, setofferdata] = useState<any>([]);
  const [engagements, setEngagements] = useState<{ [productId: number]: EngagementData }>({});
  const [activeProduct, setActiveProduct] = useState<Product | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newComment, setNewComment] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
  }, [engagements]);

  const fetchEngagementData = async (productId: number) => {
    try {
      const response: any = await GET(`${API.FIND_ONE_ENGAGEMENT_BUTTON}${productId}`, {});
      const data = response?.data || []; // ✅ Fix here

      console.log(`📊 Raw API response for product ${productId}:`, data);

      if (!Array.isArray(data) || data.length === 0) {
        console.log(`⚠️ No engagement data for product ${productId}`);
        setEngagements((prev) => ({
          ...prev,
          [productId]: {
            EngagementLike: 0,
            EngagementShare: 0,
            EngagementComments: [],
          },
        }));
        return;
      }

      // ✅ Aggregate all engagement data
      let totalLikes = 0;
      let totalShares = 0;
      const allComments: string[] = [];

      data.forEach((item: any) => {
        const likes = Number(item.EngagementLike) || 0;
        const shares = Number(item.EngagementShare) || 0;
        totalLikes += likes;
        totalShares += shares;

        if (item.EngagementComments && item.EngagementComments.trim()) {
          try {
            const parsed = JSON.parse(item.EngagementComments);
            if (Array.isArray(parsed)) {
              allComments.push(...parsed.filter((c: string) => c && c.trim() && c !== "string"));
            } else if (typeof parsed === "string" && parsed.trim() && parsed !== "string") {
              allComments.push(parsed);
            }
          } catch {
            if (item.EngagementComments !== "string" && item.EngagementComments.trim()) {
              allComments.push(item.EngagementComments);
            }
          }
        }
      });

      const uniqueComments = Array.from(new Set(allComments));

      setEngagements((prev) => ({
        ...prev,
        [productId]: {
          EngagementLike: totalLikes,
          EngagementShare: totalShares,
          EngagementComments: uniqueComments,
        },
      }));
    } catch (error) {
      console.error(`❌ Error fetching engagement for product ${productId}:`, error);
    }
  };


  useEffect(() => {
    if (data?.length > 0) {
      data.forEach((product: any) => {
        fetchEngagementData(product.id);
      });
    }
  }, [data]);

  // ---------------------- Like Button ----------------------
  const handleLike = async (product: Product) => {
    try {
      const prev = engagements[product.id] || {
        EngagementLike: 0,
        EngagementComments: [],
        EngagementShare: 0,
      };

      console.log(`👍 Liking product ${product.id}, current count: ${prev.EngagementLike}`);

      // Update UI instantly
      setEngagements((prevData) => ({
        ...prevData,
        [product.id]: {
          ...prev,
          EngagementLike: prev.EngagementLike + 1
        }
      }));

      // Send only increment of 1
      const postResponse = await POST(API.CREATE_ENGAGEMENT_BUTTON, {
        productId: product.id,
        EngagementLike: 1,
        EngagementComments: JSON.stringify([]),
        EngagementShare: 0,
      });

      console.log('Like response:', postResponse);

      notification.success({ message: "Liked!" });

      // Refresh to get accurate count
      setTimeout(() => {
        fetchEngagementData(product.id);
      }, 500);
    } catch (error) {
      console.error("❌ Error liking product:", error);
      notification.error({ message: "Failed to like" });

      // Revert on error
      const prev = engagements[product.id];
      if (prev) {
        setEngagements((prevData) => ({
          ...prevData,
          [product.id]: {
            ...prev,
            EngagementLike: Math.max(0, prev.EngagementLike - 1)
          }
        }));
      }
    }
  };

  // ---------------------- Comment Submit ----------------------
  const handleCommentSubmit = async (product: Product) => {
    if (!newComment.trim()) {
      notification.warning({ message: "Please enter a comment" });
      return;
    }

    const commentToAdd = newComment.trim();
    const prev = engagements[product.id] || {
      EngagementLike: 0,
      EngagementComments: [],
      EngagementShare: 0,
    };

    console.log(`💬 Adding comment "${commentToAdd}" to product ${product.id}`);

    // Update UI instantly
    setEngagements((prevData) => ({
      ...prevData,
      [product.id]: {
        ...prev,
        EngagementComments: [...prev.EngagementComments, commentToAdd]
      }
    }));
    setNewComment("");
    setIsModalOpen(false);

    try {
      setLoading(true);

      // Send only the new comment
      const postResponse = await POST(API.CREATE_ENGAGEMENT_BUTTON, {
        productId: product.id,
        EngagementLike: 0,
        EngagementComments: JSON.stringify([commentToAdd]),
        EngagementShare: 0,
      });

      console.log('Comment response:', postResponse);

      notification.success({ message: "Comment added!" });

      // Refresh
      setTimeout(() => {
        fetchEngagementData(product.id);
      }, 500);
    } catch (error) {
      console.error("❌ Error adding comment:", error);
      notification.error({ message: "Failed to add comment" });

      // Revert UI
      setEngagements((prevData) => ({
        ...prevData,
        [product.id]: {
          ...prev,
          EngagementComments: prev.EngagementComments.filter(c => c !== commentToAdd)
        }
      }));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const checkScrollTop = () => {
      if (window.scrollY > 300) {
        setShowScroll(true);
      } else {
        setShowScroll(false);
      }
    };
    window.addEventListener('scroll', checkScrollTop);
    return () => window.removeEventListener('scroll', checkScrollTop);
  }, []);


  const fetchOneProduct = async () => {
    try {
      setIsLoading(true);
      const api = API.GET_ONE_PRODUCT + id;
      const response: any = await GET(api, {});

      if (response?.data) {
        setData(response.data);
        setProductImages([
          response.data.productImage1,
          response.data.productImage2,
          response.data.productImage3,
          response.data.productImage4
        ].filter(Boolean)); // Remove falsy values like null, undefined
      }
    } catch (error) {
      console.error("Error fetching product:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const shareOnWhatsApp = async (product: Product) => {
    const productOffers = Array.isArray(offerdata)
      ? offerdata.filter((offer) => offer.Product_id === product.id)
      : [];
    const offer = productOffers.length > 0 ? productOffers[0] : null;
    const finalPrice = offer ? offer.Offer_price : product.Price;
    const BASE_URL = 'https://mj4p.com';
    const productUrl = `${BASE_URL}/product/${product.id}`;
    const hasValue = (value: any) => {
      return value !== null &&
        value !== undefined &&
        value !== '' &&
        value !== '.' &&
        value.toString().trim() !== '' &&
        value.toString().trim() !== '.';
    };
    let messageParts = [];
    messageParts.push(
      `🛒 കേരളപ്ലസ് ഓൺലൈൻ ഷോപ്പിംഗ്\n📦 ഇന്ത്യ മുഴുവൻ ഡെലിവറി ലഭ്യമാണ്\n🤝 വിശ്വാസത്തോടെയും ഉറപ്പോടെയും...`
    );
    messageParts.push(`Buy here: ${productUrl}`);
    if (hasValue(product.productImage1)) {
      messageParts.push(`View product images at the link below`);
    }
    if (hasValue(product.productTitle)) {
      const stockStatus = product.stock_product === 'Out of Stock' ? ' (Out of Stock)' : '';
      messageParts.push(`*${product.productTitle}*${stockStatus}`);
    }
    if (hasValue(finalPrice)) {
      const priceText = offer ? `Rs.${finalPrice} (Offer Price)` : `Rs.${finalPrice}`;
      messageParts.push(`Price: ${priceText}`);
    }
    if (hasValue(product.descriptionProduct)) {
      messageParts.push(`Description: ${product.descriptionProduct}`);
    }
    if (hasValue(product.brand)) {
      messageParts.push(`Brand: ${product.brand}`);
    }
    if (hasValue(product.color)) {
      messageParts.push(`Color: ${product.color}`);
    }
    if (hasValue(product.gender)) {
      messageParts.push(`Gender: ${product.gender}`);
    }
    if (hasValue(product.size)) {
      messageParts.push(`Size: ${product.size}`);
    }
    if (hasValue(product.shipping)) {
      messageParts.push(`Shipping: ${product.shipping}`);
    }

    const message = `Check out this product:\n\n${messageParts.join('\n\n')}`;
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');

    // Track share
    try {
      const prev = engagements[product.id] || {
        EngagementLike: 0,
        EngagementComments: [],
        EngagementShare: 0,
      };

      console.log(`🔗 Sharing product ${product.id}, current count: ${prev.EngagementShare}`);

      // Update UI instantly
      setEngagements((prevData) => ({
        ...prevData,
        [product.id]: {
          ...prev,
          EngagementShare: prev.EngagementShare + 1
        }
      }));

      // Send increment
      await POST(API.CREATE_ENGAGEMENT_BUTTON, {
        productId: product.id,
        EngagementLike: 0,
        EngagementComments: JSON.stringify([]),
        EngagementShare: 1,
      });

      // Refresh
      setTimeout(() => {
        fetchEngagementData(product.id);
      }, 500);
    } catch (error) {
      console.error("❌ Error tracking share:", error);
    }
  };


  const [isInCart, setIsInCart] = useState(false);

  const handleAddToCart = async (product: any) => {
    try {
      let cartId = Number(localStorage.getItem('cartId'));
      if (!cartId) {
        const createCartResponse: any = await POST(API.CREATE_CART, {});
        cartId = createCartResponse?.id;
        localStorage.setItem('cartId', String(cartId));
      }

      const quantity = 1;
      const partnerId = Number(product.clientId || 1);

      // 🧩 Make sure offerdata exists
      if (!offerdata || !offerdata.length) {
        console.warn("⚠️ offerdata is empty");
      }

      // 🧠 Find matching offer
      const now = dayjs();
      const productOffer = offerdata?.find((offer: any) => {
        const offerProductId = Number(
          offer.Product_id || offer.productId || offer.ProductId || offer.product?.id
        );

        // Check if this offer matches the current product
        if (offerProductId !== product.id) return false;

        // Check if offer time is valid
        const start = offer.Offer_start_time ? dayjs(offer.Offer_start_time) : null;
        const end = offer.Offer_End_time ? dayjs(offer.Offer_End_time) : null;
        const isActive =
          (!start || now.isAfter(start)) &&
          (!end || now.isBefore(end));

        return isActive;
      });

      // 💰 Decide final price
      const finalPrice = productOffer
        ? Number(productOffer.Offer_price)
        : Number(product.Price);

      console.log("🧩 Product:", product.name);
      console.log("➡️ Offer Found:", productOffer);
      console.log("💸 Final Price Used:", finalPrice);

      const payload = {
        cartId: Number(cartId),
        productId: Number(product.id),
        partnerId: Number(partnerId),
        quantity,
        price: finalPrice,
        subtotal: quantity * finalPrice,
        totalPrice: quantity * finalPrice,
      };

      const addItemResponse: any = await POST(API.ADD_TO_CART, payload);

      if (addItemResponse?.status) {
        notification.success({ message: "✅ Product added to cart!" });
        setIsInCart(true);
      } else {
        notification.warning({
          message:
            addItemResponse?.message || "⚠️ Product already in cart",
        });
        setIsInCart(true);
      }
    } catch (err) {
      console.error("❌ Add to cart failed:", err);
      notification.error({ message: "❌ Failed to add product to cart" });
    }
  };
  const fetchofferproduct = async () => {
    try {
      setIsLoading(true);
      const url = API.ACTIVE_OFFER_PRODUCT;
      const response: any = await GET(url, {});

      if (response?.data && Array.isArray(response.data)) {
        setofferdata(response.data.map((item: any) => ({
          ...item,
          Offer_start_time: item.Offer_start_time ?
            dayjs.utc(item.Offer_start_time).tz('Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss') : '',
          Offer_End_time: item.Offer_End_time ?
            dayjs.utc(item.Offer_End_time).tz('Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss') : ''
        })));
      } else {
        setofferdata([]); // Ensure it's always an array
      }
    } catch (error) {
      console.error("Error fetching offer data:", error);
      setofferdata([]); // Prevent undefined issues
    } finally {
      setIsLoading(false);
    }
  };
  // --- CART CHECK STATE ---
  const [cartHasItems, setCartHasItems] = useState(false);
  const [cartId, setCartId] = useState<string | null>(null);
  useEffect(() => {
    const checkCart = async () => {
      const storedCartId = localStorage.getItem('cartId');
      if (!storedCartId) return;

      try {
        const response: any = await GET(`${API.LISTING_CART_DATA}${storedCartId}`, {});
        if (response?.data && response.data.length > 0) {
          setCartHasItems(true);
          setCartId(storedCartId);
        } else {
          setCartHasItems(false);
        }
      } catch (error) {
        console.error("Error checking cart:", error);
        setCartHasItems(false);
      }
    };

    checkCart();
  }, [isInCart]);
  const filterProductData = async () => {
    try {
      setIsLoading(true);
      // Create an object but only keep values that are not empty
      let obj = { category_id: Number(id) };


      const api = API.PRODUCT_FILTER;
      const response: any = await POST(api, obj);

      if (response?.data) {
        setProductfilterData(response?.data);
      } else {
        console.error("Data not available:", response);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };


  // console.log("object", ProductfilterData?.categoryid?.categoryTitle)
  useEffect(() => {
    {
      filterProductData();
      fetchofferproduct()

    }
  }, []);// Refetch when `id` changes
  useEffect(() => {
    {
      fetchOneProduct()
    }
  }, []);// Refetch when `id` changes

  const [showScroll, setShowScroll] = useState(false);

  // Show the button when scrolling down
  useEffect(() => {
    const checkScrollTop = () => {
      if (window.scrollY > 300) {
        setShowScroll(true);
      } else {
        setShowScroll(false);
      }
    };
    window.addEventListener('scroll', checkScrollTop);
    return () => window.removeEventListener('scroll', checkScrollTop);
  }, []);

  // Scroll to the top when clicking the button
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  return (
    <div>
      {cartHasItems && (
        <div
          style={{
            position: 'fixed',
            bottom: '55px',
            right: '10px',
            zIndex: 9999,
          }}
        >
          <Button
            type="primary"
            size="large"
            style={{
              backgroundColor: '#1890ff',
              border: 'none',
              borderRadius: '8px',
              padding: '12px 24px',
              boxShadow: '0px 4px 8px rgba(0,0,0,0.2)',
            }}
            onClick={() => navigate(`/cart/${cartId}`)}
          >
            🛒 Go to Cart
          </Button>
        </div>
      )}

      {showScroll && (
        <button className="scroll-top-button" onClick={scrollToTop}>
          <FontAwesomeIcon icon={faArrowUp} />
        </button>
      )}
      <Header />
      <div className="about-header">
        <img src={background} alt="About Us Background" />
        <h1 className="about-title">Category : {ProductfilterData?.[0]?.categoryid?.categoryTitle} </h1>
      </div>
      <div>
        <Subcategory id={id} />
      </div>
      <div>
        <div className="product-lists">
          {ProductfilterData?.map((product: any, index: number) => {
            const productImages = [
              product.productImage1,
              product.productImage2,
              product.productImage3
            ].filter(Boolean); // Remove undefined/null values
            const isOutOfStock = product?.stock_product === 'Out of Stock';

            return (
              <div key={index} className="product-card">
                <div className="carousel-container">
                  <Carousel autoplay autoplaySpeed={3000} arrows>
                    {productImages.map((image, imgIndex) => (
                      <img
                        key={imgIndex}
                        src={image}
                        alt={product.productTitle}
                        className="carousel-images"
                        onClick={() => navigate(`/product/${product.id}`)}
                      />
                    ))}
                  </Carousel>

                </div>
                <div className="function-button-product">
                  <div className="function-button-product">
                    <Button
                      onClick={() => handleAddToCart(product)}
                      disabled={isOutOfStock}
                    >
                      {isOutOfStock ? 'OUT OF STOCK' : 'ADD TO CART'}
                    </Button>

                    <div className="button-rows">
                      {/* Share */}
                      <div className="icon-buttons icon-button share" onClick={() => shareOnWhatsApp(product)}>
                        <Share2 size={18} />
                        <span className="like-count">
                          {engagements[product.id]?.EngagementShare || 0}
                        </span>
                      </div>

                      {/* Comment */}
                      <div
                        className="icon-buttons icon-button comment"
                        onClick={() => {
                          setActiveProduct(product);
                          setIsModalOpen(true);
                        }}
                      >
                        <MessageCircle size={18} />
                        <span className="like-count">
                          {engagements[product.id]?.EngagementComments?.length || 0}
                        </span>
                      </div>

                      {/* Like */}
                      <div className="like-section">
                        <div
                          className={`icon-buttons icon-button like ${engagements[product.id]?.EngagementLike > 0 ? "active" : ""
                            }`}
                          onClick={() => handleLike(product)}
                        >
                          <Heart
                            size={18}
                            fill={engagements[product?.id]?.EngagementLike > 0 ? "red" : "none"}
                          />
                        </div>
                        <span className="like-count">
                          {engagements[product.id]?.EngagementLike || 0}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* 💬 Comment Modal */}
                  <Modal
                    title="Comments"
                    open={isModalOpen}
                    onCancel={() => setIsModalOpen(false)}
                    footer={null}
                  >
                    <div style={{ maxHeight: "150px", overflowY: "auto", marginBottom: "10px" }}>
                      {activeProduct && engagements[activeProduct.id]?.EngagementComments?.length ? (
                        engagements[activeProduct.id].EngagementComments.map((cmt: any, index: any) => (
                          <p key={index} style={{ borderBottom: "1px solid #eee", padding: "5px 0" }}>
                            {cmt}
                          </p>
                        ))
                      ) : (
                        <p style={{ color: "#aaa" }}>No comments yet</p>
                      )}
                    </div>

                    <Input.TextArea
                      rows={2}
                      value={newComment}
                      onChange={(e: any) => setNewComment(e.target.value)}
                      placeholder="Write a comment..."
                    />

                    <Button
                      type="primary"
                      block
                      style={{ marginTop: "10px" }}
                      onClick={() => activeProduct && handleCommentSubmit(activeProduct)}
                      loading={loading}
                    >
                      Add Comment
                    </Button>
                  </Modal>
                </div>
                <br />
                <h2 className="product-name">{product.productTitle}</h2>
                <li style={{ listStyle: "none" }}> Rs:<b>{product.Price}</b><li> {product.descriptionProduct}</li> </li>
                <button onClick={() => navigate(`/product/${product.id}`)}>View Details</button>
              </div>
            );
          })}
        </div>
      </div>
      <FooterWeb />
    </div>
  )
}

export default Categoryviewpage
